<template>
    <div class="RiskMannNotificacionesPush">
        <div class="toast-container position-fixed bottom-0 start-50 translate-middle-x p-3">
            <div id="notificacionPushToast" class="toast" role="alert" aria-live="assertive" aria-atomic="true"
                data-bs-autohide="false">
                <div class="toast-header">
                    <strong class="me-auto">¡Nuevo Mensaje!</strong>
                    <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
                </div>
                <div class="toast-body">
                    ¿Deseas recibir las últimas actualizaciones de RiskMann?
                    <div class="mt-2 pt-2 border-top">
                        <button type="button" class="btn btn-primary btn-sm" @click="activarPermiso()">
                            Aceptar</button>
                        <button type="button" class="btn btn-secondary btn-sm ms-1"
                            data-bs-dismiss="toast">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { auth, db, messaging } from "@/firebase";
import { getToken } from "firebase/messaging";
import { collection, query, where, getDocs, limit, doc, setDoc, serverTimestamp, orderBy } from "firebase/firestore";
import { Toast } from "bootstrap";
export default {
    name: "RiskMannNotificacionesPush",

    data() {
        return {
            idUsuario: null
        }
    },

    async created() {
        const esModoSinConexion = await this.$store.state.obtenerModoSinConexion();
        if (!esModoSinConexion) {
            const usuario = auth.currentUser;
            if (usuario) {
                const usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
                if (usuarioDB) {
                    this.idUsuario = usuarioDB.id;
                    await this.detectarDispostivo();
                }
            }
        }
    },

    methods: {
        async crearSuscripcion(token) {
            const refSuscripcion = doc(collection(db, "suscripciones"));
            await setDoc(doc(db, "riskmann_suscripciones", refSuscripcion.id), {
                id: refSuscripcion.id,
                idUsuario: this.idUsuario,
                token: token,
                temas: [
                    "Publicidad",
                    "Actualizaciones-App"
                ],
                registro: {
                    creacion: serverTimestamp(),
                    actualizacion: serverTimestamp(),
                }
            });
        },

        async obtenerSuscripcion() {
            let suscripcion = null;
            const q = query(collection(db, "riskmann_suscripciones"), where("idUsuario", "==", this.idUsuario), orderBy("registro.creacion", "desc"), limit(1));
            const querySnapshot = await getDocs(q);
            querySnapshot.forEach((doc) => {
                suscripcion = doc.data()
            });
            return suscripcion;
        },

        async verificarSuscripcion() {
            try {
                const registration = await navigator.serviceWorker.ready;
                getToken(messaging, { 
                    serviceWorkerRegistration: registration,
                    vapidKey: "BE6-4TekQMr6_72NF2YO9b1DnhYiEIreJsKRuZ-eQo323B7xYx_vPnDgmODMfTIT0jUzICsRfJ1Az3opGPQWRPI" 
                }).then(async (token) => {
                    if (token) {
                        let obtenerSuscripcion = await this.obtenerSuscripcion();
                        if (!obtenerSuscripcion) {
                            await this.crearSuscripcion(token);
                        }
                    }
                });
            } catch (error) {
                console.error("Error al obtener token de suscripción:", error);
            }
        },

        activarPermiso() {
            Notification.requestPermission().then((permission) => {
                if (permission === 'granted') {
                    const notificacionPushToast = document.getElementById('notificacionPushToast');
                    const toast = new Toast(notificacionPushToast);
                    toast.hide();
                    this.verificarSuscripcion();
                } else {
                    console.log('No se ha aceptado el permiso para recibir notificaciones.');
                }
            });
        },

        detectarDispostivo() {
            var mobile = {
                Android: function () {
                    return navigator.userAgent.match(/Android/i);
                },
                BlackBerry: function () {
                    return navigator.userAgent.match(/BlackBerry/i);
                },
                iOS: function () {
                    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                },
                Opera: function () {
                    return navigator.userAgent.match(/Opera Mini/i);
                },
                Windows: function () {
                    return navigator.userAgent.match(/IEMobile/i);
                },
                any: function () {
                    return (mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows());
                }
            };
            if (mobile.any()) {
                var permission = Notification.permission;
                if (permission === 'default') {
                    const notificacionPushToast = document.getElementById('notificacionPushToast');
                    const toast = new Toast(notificacionPushToast);
                    toast.show();
                } else {
                    this.verificarSuscripcion();
                }
            }
        }
    }
}
</script>